import PropTypes from 'prop-types';
import React from 'react';

//Components
import SlickSlider from './SlickSlider';

const SlickCaseContents = ({ caseContents, onProductTransition }) => {
  // let caseContents = props.itemDetails.caseDetailsList;
  let singleBottleClass = caseContents.length === 1 ? ' single' : '';
  let slidesToShow = caseContents.length === 1 ? 1 : caseContents.length;

  //Filter the LT / Letter Codes
  caseContents = caseContents?.filter(item => {
    return item.skuItemCode.indexOf('LT') === -1 && item.skuItemCode.indexOf('SB') === -1;
  });

  let handleError = e => {
    e.target.src = '/images/us/common/default_bottle_small.png';
  };

  let handleSlideTransition = index => {
    onProductTransition(index, caseContents?.[index]?.referencedProduct);
  };

  return (
    <div className="slick-case-contents">
      <SlickSlider
        items={caseContents}
        navEnabled={true}
        slidesToShow={window.innerWidth < 768 ? 1 : slidesToShow}
        getActiveSlide={handleSlideTransition}
      >
        {caseContents.map((itemContents, index) => {
          let item = itemContents.referencedProduct;

          let isAdvent = item?.itemCode?.substr(-2) == 50 && !item?.itemCode?.match('/^[a-z]+$/i');
          return (
            <div key={index} className={'item-pod' + singleBottleClass}>
              <img
                className="carousel-item-image"
                src={'/images/us/en/product/' + item.itemCode + '.png'}
                onError={e => handleError(e)}
                alt={item.name}
                // width={item.mixed || isAdvent ? "" : "36px"}
                height={'150px'}
                onClick={() => handleSlideTransition(index)}
                role="presentation"
                style={{ cursor: 'pointer', objectFit: 'contain', maxHeight: '150px' }}
              />
              <p>
                <strong>X{caseContents[index].quantity}</strong>
              </p>
            </div>
          );
        })}
      </SlickSlider>
    </div>
  );
};

/*
     Define Prop types
 */
SlickCaseContents.propTypes = {
  caseContents: PropTypes.array.isRequired,
  onProductTransition: PropTypes.func.isRequired,
};

export default SlickCaseContents;
